/* eslint-disable */
export default {
  components: [
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Descripción",
      key: "descripcion",
      placeholder: "",
      prefix: "",
      suffix: "",
      rows: 3,
      multiple: false,
      defaultValue: "",
      protected: false,
      persistent: true,
      hidden: false,
      wysiwyg: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: true,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: ""
      },
      type: "textarea",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Subir imagen, o archivo word, excel, pdf, texto plano",
      key: "archivo",
      image: false,
      imageSize: "200",
      placeholder: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      filePattern: ".jpg,.png,.xlsx,.docx,.pdf,.txt",
      fileMinSize: "0KB",
      fileMaxSize: "1GB",
      type: "file",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true,
      validate: {
        required: true
      },
      storage: "base64"
    },
    {
      autofocus: false,
      input: true,
      label: "Cargar y Guardar",
      tableView: false,
      key: "submit",
      size: "md",
      leftIcon: "fa fa-save",
      rightIcon: "",
      block: false,
      action: "submit",
      disableOnInvalid: false,
      theme: "success",
      type: "button",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: false
    }
  ]
}
